<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/kangmu.png" alt="">
            <div class="company">四川省康牧动保科技有限公司</div>
          </div>
          <div class="labInfo">
            <span>康牧</span>
            <span>动保</span>
            <span>畜牧</span>
            <span>疫苗</span>
            <span>兽药</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/kangmu1@3x.png" alt="">
            <div class="companyWord">四川省康牧动保是顺应行业发展变革应运而生的一家科技型领先动保产品提供与服务专业化公司。主要实施川渝美国硕腾动保、广东永顺生物、天康口蹄疫苗等一流产品与专业系统服务。公司厉行诚信、规范、务实、高效的工作作风，全面运营高专业水平服务团队，整合行业和高等院校专家资源，已成为西南地区领航的科技型专业化动保服务公司。专业、服务、价值、发展是公司经营的核心理念，以专业保障服务、以服务体现价值、以价值驱动发展、以发展成就事业。以构建客户、员工、公司共同发展利益为己任，为提升用户养殖效益促进行业发展与进步贡献应有的一份力量！依托专业优势，立足资源整合，强化合作践行，铸造共同利益，以共同发展为核心，切实为用户降低风险，提高生产成绩，藉此共建畜牧业发展新时期共赢合作新模式！</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/kangmu2@3x.png" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/kangmu3@3x.png" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> 兽用生物制品、消毒剂、化学药品、中药制剂、内外用杀虫剂</div>
      </div>
      <footer class="nongmu-footer">
        <!-- <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.jinghai.net/">http://www.jinghai.net/</a></dd>
        </!--> -->
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>四川省成都市龙泉驿区成龙大道2段1118号中物国际3号楼11层7号</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
